<template>
  <!-- The Modal -->
  <div id="myModal" class="modal" :class="{ active: isOpen }" tabindex="0">
    <div
      id="modal-bg"
      class="absolute w-full h-full top-0 left-0"
      @click.stop="closeModal()"
    ></div>
    <!-- Modal content -->
    <div class="modal-content">
      <span @click="closeModal()" class="close">&times;</span>
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: "modalComponent",
  props: ["value"],
  computed: {
    isOpen() {
      return this.value;
    }
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeydown);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    handleKeydown(event) {
      if (event.key === "Escape") {
        event.stopPropagation();
        this.closeModal();
      }
    },
    closeModal() {
      this.$emit("input", !this.isOpen);
    }
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.$nextTick(() => {
          document.getElementById("myModal").focus();
        });
      }
    }
  }
};
</script>
<style>
/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding: 100px 16px 16px; /* Location of the box, with side gutters on small screens */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  box-sizing: border-box;
}

.active {
  display: block !important;
}
/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #ff4b4b;
  border-radius: 7px;
  min-height: 300px;
  position: relative;
  width: 600px;
  max-width: 100%;
  box-sizing: border-box;
}

@media (max-width: 640px) {
  .modal {
    padding: 24px 8px 8px;
  }
  .modal-content {
    padding: 16px;
  }
}

/* The Close Button */
.close {
  color: #aaaaaa;
  font-size: 28px;
  font-weight: bold;
  position: absolute;
  right: 15px;
  top: 5px;
  z-index: 1000;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
</style>
